import { debounce, type Effect, type ForkEffect, put, takeEvery } from 'redux-saga/effects';
import * as Effects from 'redux-saga/effects';
import { type PayloadAction } from '@reduxjs/toolkit';

import * as Api from '~/api';

import type { User } from '~/types/models';

import { actions } from './slice';

const call: any = Effects.call;

export function* watchAddDocumentationPageSeen({ payload }: PayloadAction<string>): Generator<Effect, void, any> {
  try {
    yield call(Api.addDocumentationPageSeen, payload);
    yield put(actions.addDocumentationPageSeenToUserMeta(payload));
  } catch (e) {
    Api.handleError(e);
  }
}

export function* watchLogin(): Generator<Effect, void> {
  yield put(actions.setLoading(true));
  document.location.href = `${Api.API_PATH}/auth/login`;
}

export function* watchLogout(): Generator<Effect, void> {
  yield put(actions.setLoading(true));
  try {
    yield put(actions.hideSentryWidget());

    yield put(actions.setUser(null));
    document.location.href = Api.LOGOUT_URL;
  } catch (e) {
    Api.handleError(e);
  } finally {
    yield put(actions.setLoading(false));
  }
}

export function* watchFetchUser(): Generator<Effect, void, User> {
  yield put(actions.setLoading(true));

  try {
    const user = yield call(Api.fetchUser);
    yield put(actions.setUser(user));

    if (user.roles?.find((r) => r.slug === 'Admin')) {
      yield put(actions.showSentryWidget());
    }

    yield put(actions.setLoaded(true));
  } catch (e) {
    // Pokecatch
    yield put(actions.setUser(null));
  } finally {
    yield put(actions.setLoading(false));
  }
}

export function* watchAuthSagas(): Generator<ForkEffect, void> {
  yield takeEvery(actions.addDocumentationPageSeen, watchAddDocumentationPageSeen);
  yield takeEvery(actions.login, watchLogin);
  yield takeEvery(actions.logout, watchLogout);
  yield debounce(500, actions.fetchUser, watchFetchUser);
}

const authSagas = watchAuthSagas;

export default authSagas;
